import { gql } from '@apollo/client';

/**
 * 当前登录用户的页面水印信息。
 *
 * 后端五个字段均为非空（无手机号账号的 accountTail 由后端兜底成空串），
 * 前端不做可空分支 —— 见 docs/plans/feature-wangxiaoyu-watermark.md 决策 2。
 */
export const CURRENT_USER_WATERMARK = gql`
  query CurrentUserWatermark($timezone: String) {
    currentUserWatermark(timezone: $timezone) {
      enabled
      userId
      userName
      accountTail
      date
    }
  }
`;
